import { Inject, Pipe, PipeTransform } from "@angular/core";
import * as momentImport from "moment-timezone";

import {
    DATETIME_FORMAT,
    TIMEZONE,
} from "../tokens/index";

const moment = momentImport as any; // required for rollup to work without a TypeScript error

@Pipe({ name: "spsDatetime" })
export class SpsDatetimePipe implements PipeTransform {
    constructor(
        @Inject(DATETIME_FORMAT) private datetimeFormat,
        @Inject(TIMEZONE) private timezone
    ) {}

    transform(datetime: any): string {
        if (!moment.isMoment(datetime)) {
            datetime = moment(datetime);
        }
        if (moment.defaultZone.abbrs.indexOf(datetime.zoneAbbr()) === -1) {
            datetime = datetime.clone().tz(this.timezone);
        }
        if (datetime.isValid()) {
            return datetime.format(this.datetimeFormat);
        }
    }
}
